<template>
    <div>
        <div class="div-height div">
            <div class="left">
                <el-button
                    type="primary"
                    @click="handleOpen('is_add', '添加案例')"
                    >添加案例</el-button
                >

            </div>
        </div>



        <el-card shadow="hover">
            <el-table v-loading="list.loading" :data="list.data">
                <el-table-column label="ID" prop="id" width="50" align="center"></el-table-column>
                <el-table-column label="名称" prop="CaseName" align="center" ></el-table-column>
                <el-table-column label="浏览数" prop="readCount" align="center" width="80"></el-table-column>
                <el-table-column label="下载数" prop="downloadCount" align="center" width="80"></el-table-column>
                <el-table-column label="创建者" prop="owner_name" align="center" width="120"></el-table-column>
               
                <el-table-column label="学院-专业" align="center">
                        <template v-slot="scope">
                        {{ scope.row.major.college.name }} - {{ scope.row.major.name }}
                        </template>
                </el-table-column>
                <el-table-column label="状态" prop="owner_name" align="center" width="120">
                    <template v-slot="scope">
                        <!-- 根据 state 字段的值显示不同的内容和图标 -->
                        <div class="status-with-icon">
                            
                        <span v-if="scope.row.state === 0" class="status-text" >
                            编辑中 <i class="el-icon-edit"></i>
                        </span>
                        <span v-else-if="scope.row.state === 8" class="status-text">
                            已退回
                        </span>
                        <span v-else-if="scope.row.state === 1" class="status-text">
                             学院审核中
                        </span>
                        <span v-else-if="scope.row.state === 2" class="status-text">
                             校级审核中
                        </span>
                        <span v-else class="status-text">
                             已上线<i class="el-icon-upload"></i>
                        </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" >
                    <template v-slot="scope">
                        <!-- 操作按钮 -->
                        <div class="operation-buttons">
                            
                            <el-button  type="info" @click="handlePreView(scope.row)"> 预览</el-button>
                          
                            <span v-show="btEdit">
                                 <el-button type="info" @click="handleEdit(scope.row)" > 编辑</el-button>
                            </span>
                            <span v-show="btReturn">
                                <el-button type="warning" @click="handleBack(scope.row)" > 退回 </el-button>
                            </span>
                            <span v-show="issubmitButtonVisible(scope.row).isVisible">
                                <el-button type="primary" @click="handleSubmit(scope.row)" >  {{ issubmitButtonVisible(scope.row).text }} </el-button>
                            </span>

                            <span v-show="btDelete">

                                <el-button type="danger" @click="handleOpen(
                                        'is_delete',
                                        '删除案例',
                                        scope.$index,
                                        scope.row
                                    )" > 删除 </el-button>

                            </span>
                           
                           
                    </div>
                    </template>
                </el-table-column>
            </el-table>
            <br />
            <el-pagination
                :current-page="list.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="list.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="list.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            >
            </el-pagination>
        </el-card>


        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="30%"
        >
            <span>
                <span
                    v-if=" handleSign != 'is_delete' "
                >
                <div class="hierarchy">
                    <span class="item">教师提交</span>
                    <span class="arrow">-></span>
                    <span class="item">院级审核</span>
                    <span class="arrow">-></span>
                    <span class="item">校级审核</span>
                    <span class="arrow">-></span>
                    <span class="item">上线</span>
                </div>
            </br>
                    <el-input
                        v-model="caseName"
                        placeholder="请输入案例名称"
                    ></el-input>
                </span>
                <span v-else class="dialog-span">您确定要删除 "{{caseName}}" 么？</span>
            </br></br>
                <!-- 专业选择 -->
                <span v-if=" handleSign == 'is_add' ">
                    <el-select
                        v-model="selectedMajor"
                        placeholder="请选择专业"
                        filterable
                        @change="handleSelectChange"
                    >
                        <el-option
                            v-for="major in majorOptions"
                            :key="major.id"
                            :label="major.name"
                            :value="major.id"
                        ></el-option>
                    </el-select>
                </span>


            </span>
            <span
                slot="footer"
                class="dialog-footer"
            >
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFix()">确 定</el-button>
            </span>
        </el-dialog>
    </div>

   
</template>

<script>
import CaseList from "@/assets/js/manager/CaseList.js";
export default {
    ...CaseList
};
</script>


<style scoped>
/* 确保按钮在一行中排列 */
.operation-buttons {
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 5px; /* 按钮之间的间距 */

}

.operation-buttons .el-button {
  padding: 6px 6px; /* 减小内边距 */
  font-size: 12px; /* 减小字体大小 */
}

.div-height{
    height: 55px;
}
</style>
<style scoped>
.hierarchy {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #333;
  gap: 8px; /* 控制间隔 */
}

.item {
  font-weight: bold;
  color: rgb(64, 158, 255); /* 绿色字体 */
  padding: 4px 8px;
  border: 1px solid rgb(64, 158, 255);
  border-radius: 4px;
}

.arrow {
  color: #999; /* 箭头颜色 */
  font-weight: normal;
}
</style>